import React, {useState, useEffect, useRef} from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../../components/loader';
import Header from '../../components/header';
import { useDispatch, useSelector } from 'react-redux';
import { API_URL } from '../../constants';
import { notify } from '../../utils';
import { useNavigate, useLocation, useParams, Link  } from 'react-router-dom';
import axios from 'axios';
import { Col, Form, Row, Container, Button, Navbar, ListGroup, Dropdown, Table, Modal } from 'react-bootstrap';
import Angleright from '../../assets/images/arrow-angle-right.svg';
import DeleteIc from '../../assets/images/delete-ic.svg';
import EditIc from '../../assets/images/edit-ic.svg';
import SaveIc from '../../assets/images/save-ic.svg';
import DeleteDarkIc from '../../assets/images/delete-dark-ic.svg';
import Chevronright from '../../assets/images/chevron-right.svg';
import Addnew from '../../assets/images/add_new_ic.svg';
import Search from '../../assets/images/search-ic.svg';
import {is_user_login} from '../../utils';
import {Helmet} from "react-helmet";

const ViewProductMeta = () => {

    const [add_meta_key_input,set_add_meta_key_input] = useState('');
    const [add_meta_value_input,set_add_meta_value_input] = useState('');

    const [allow_access,set_allow_access] = useState(false);
    const [product_meta,set_product_meta] = useState([]);
    const { product_id, cat_id } = useParams();
    const [searching,set_searching] = useState(false);
    const [access, set_access] = useState([]);
    const navigate = useNavigate();
    const [inputText,setinputText] = useState('');
    const [edit_meta_key_input,set_edit_meta_key_input] = useState('');
    const [edit_meta_value_input,set_edit_meta_value_input] = useState('');
    const inputRef = useRef('');
    const add_meta_key_ref = useRef('');
    const add_meta_value_ref = useRef('');
    const edit_meta_key_ref = useRef('');
    const edit_meta_value_ref = useRef('');
    let typeCheck = undefined;
    const [modal_show,set_modal_show] = useState(false);
    const [delete_modal_show,set_delete_modal_show] = useState(false);
    const [edit_modal_show,set_edit_modal_show] = useState(false);
    const [add_product_btn_disabled,set_add_product_btn_disabled] = useState(false);
    const [delete_product_btn_disabled,set_delete_product_btn_disabled] = useState(false);
    const [update_product_btn_disabled,set_update_product_btn_disabled] = useState(false);
    const [add_meta_key_error,set_add_meta_key_error] = useState('');
    const [add_meta_value_error,set_add_meta_value_error] = useState('');
    const [edit_meta_value_error,set_edit_meta_value_error] = useState('');
    const [edit_meta_key_error,set_edit_meta_key_error] = useState('');
    const user_id = useSelector((state) => state.set_user_id);
    const user_data = useSelector((state) => state.set_user_data);
    const [delete_product_meta_key,set_delete_product_meta_key] = useState(undefined);
    const [delete_product_cat_id,set_delete_product_cat_id] = useState(undefined);
    const [delete_product_id,set_delete_product_id] = useState(undefined);
    const [edit_product_id,set_edit_product_id] = useState(undefined);
    const [edit_product_cat_id,set_edit_product_cat_id] = useState(undefined);
    const [edit_product_meta_key,set_edit_product_meta_key] = useState(undefined);
    const [breadcrumb_product_name,set_breadcrumb_product_name] = useState('');
    const [breadcrumb_product_meta_name,set_breadcrumb_product_meta_name] = useState('');

    useEffect(() => {
        if(searching == true)
        {
            filter_product_meta();
        }
    },[searching]);

    const filter_product_meta = async() => {
        const formData = {
            user_id: user_id,
            store_id: user_data.store_id,
            search: inputText,
            category_id: cat_id,
            product_id: product_id
        };
        const response = await axios.post(`${API_URL}api/productMeta/search`, formData).then(response => {
            if (response.data.status == 'success') {
                set_product_meta(response.data.data);
            }
        })
        .catch(error => {
            set_product_meta([]);
        });
        setTimeout(function(){
            set_searching(false);
        },0);
    }

    const inputChange = () => {
        clearTimeout(typeCheck);
        typeCheck = setTimeout(function(){
            set_searching(true);
            if(setinputText !== undefined)
            {
                setinputText(inputRef.current.value);
            }

            if(set_searching !== undefined)
            {
                set_searching(true);
            }

        },1000);
    }

    const open_product_modal = () => {
        if(access.includes('AddProductMeta'))
        {
            set_modal_show(true);
        }else{
            notify(toast,'error','You didn\'t have access to add new product');
        }
    }

    // Edit product
    const edit_product = async(meta_id,cid,pid,meta_key,meta_val) => {
        set_edit_modal_show(true);
        set_edit_meta_key_input(meta_key);
        set_edit_meta_value_input(meta_val);
        set_edit_meta_key_error('');
        set_edit_meta_value_error('');
    }

    const edit_modal_close = () => {
        set_edit_modal_show(false);
    }

    const update_product = async () => {
        if(edit_meta_value_ref.current.value == '')
        {
            set_edit_meta_value_error('Required field.');
        }
        // else{
        //     if(!isNumber(edit_meta_value_ref.current.value))
        //     {
        //         set_edit_meta_value_error('Invalid input. Please enter a number.');
        //     }
        // }

        if(edit_meta_value_ref.current.value != '')
        {
            set_update_product_btn_disabled(true);
            const formData = {
                user_id: user_id,
                store_id: user_data.store_id,
                category_id: edit_product_cat_id,
                product_id: edit_product_id,
                metaKey:edit_product_meta_key,
                metaValue:edit_meta_value_ref.current.value
            };
            const response = await axios.post(`${API_URL}api/productMeta/update`, formData).then(response => {
                if (response.data.status == 'success') {
                    set_edit_modal_show(false);
                    notify(toast,'success',response.data.message);
                    get_product_meta();
                    set_update_product_btn_disabled(false);
                }
            })
            .catch(error => {

                set_update_product_btn_disabled(false);
                if (axios.isAxiosError(error) && error.response) {
                    notify(toast,'error',error.response.data.message);
                } else {
                    notify(toast,'error','Server error! Please try again later.');
                }
            });
        }
    }

    // deleteConfirm
    const deleteConfirm = (meta_id,pid,cid) => {
        set_delete_modal_show(true);
    }

    const delete_modal_close = () => {
        set_delete_modal_show(false);
    }

    const delete_product_meta = async(meta_id,pid,cid) => {
        set_delete_product_btn_disabled(true);

        const formData = {
            user_id: user_id,
            store_id: user_data.store_id,
            category_id: delete_product_cat_id,
            product_id: delete_product_id,
            metaKey:delete_product_meta_key
        };
        const response = await axios.post(`${API_URL}api/productMeta/delete`, formData).then(response => {
            if (response.data.status == 'success') {
                set_delete_modal_show(false);
                notify(toast,'success',response.data.message);
                get_product_meta();
                set_delete_product_btn_disabled(false);
            }
            set_allow_access(true);
        })
        .catch(error => {
            set_delete_product_btn_disabled(false);
            set_allow_access(true);
            if (axios.isAxiosError(error) && error.response) {
                notify(toast,'error',error.response.data.message);
            } else {
                notify(toast,'error','Server error! Please try again later.');
            }
        });
    }

    const get_product_meta = async() => {
        const formData = {
            user_id: user_id,
            store_id: user_data.store_id,
            category_id: cat_id,
            product_id: product_id,
        };
        const response = await axios.post(`${API_URL}api/productMeta/getAll`, formData).then(response => {
            if (response.data.status == 'success') {
                set_product_meta(response.data.data);
            }
            set_allow_access(true);
        })
        .catch(error => {
            set_allow_access(true);
            if (axios.isAxiosError(error) && error.response) {
                notify(toast,'error',error.response.data.message);
            } else {
                notify(toast,'error','Server error! Please try again later.');
            }
        });
    }

    const verify_product = async() => {
        const formData = {
            user_id: user_id,
            store_id: user_data.store_id,
            category_id: cat_id,
            product_id: product_id,
        };
        const response = await axios.post(`${API_URL}api/product/getProduct`, formData).then(response => {
            if (response.data.status == 'success') {
                get_product_meta();
                set_breadcrumb_product_meta_name(response.data.data.name);
            }else{
                navigate(`/categories/`);
            }
        })
        .catch(error => {
            navigate(`/categories/`);
            set_delete_modal_show(false);
            if (axios.isAxiosError(error) && error.response) {
                notify(toast,'error',error.response.data.message);
            } else {
                notify(toast,'error','Server error! Please try again later.');
            }
        });

    }

    useEffect(() => {
    },[breadcrumb_product_meta_name]);

    useEffect(() => {

        if(user_id !== null && user_id !== undefined && user_id != '' && user_data !== null && user_data !== undefined && user_data.id !== undefined)
        {
            verify_category();

            set_access(user_data.access.split(','));
        }
    },[user_id,user_data]);

    // Add product meta
    const modal_close = () => {
        set_add_meta_value_error('');
        set_add_meta_key_error('');
        set_add_product_btn_disabled(false);
        set_modal_show(false);
    }

    function isNumber(str) {
    const regex = /^\d+$/;
    return regex.test(str);
    }

    // Verify that category is available or not
    const verify_category = async () => {
        const formData = {
            user_id: user_id,
            store_id: user_data.store_id,
            category_id: cat_id
        };
        const response = await axios.post(`${API_URL}api/category/getCategory`, formData).then(response => {
            if (response.data.status == 'success' && response.data.message.id == cat_id && response.data.message.store_id == user_data.store_id) {
                set_breadcrumb_product_name(response.data.message.name);
                verify_product();
            }else{
                navigate('/categories');
            }
        })
        .catch(error => {
            set_allow_access(true);
            if (axios.isAxiosError(error) && error.response) {
                // setErrorMessage(error.response.data.message);
                navigate('/categories');
            } else {
                navigate('/categories');
            }

        });
    }

    const add_product_meta = async() => {
        const meta_key = add_meta_key_ref.current.value;
        const meta_val = add_meta_value_ref.current.value;
        set_add_meta_key_error('');
        set_add_meta_value_error('');
        if(meta_key == '')
        {
            set_add_meta_key_error('Required field.');
        }
        if(meta_val == '')
        {
            set_add_meta_value_error('Required field.');
        }
        if(meta_key != '' && meta_val != '')
        {
            set_add_product_btn_disabled(true);
            const formData = {
                user_id: user_id,
                store_id: user_data.store_id,
                category_id: cat_id,
                product_id: product_id,
                metaKey:add_meta_key_ref.current.value,
                metaValue:add_meta_value_ref.current.value
            };
            const response = await axios.post(`${API_URL}api/productMeta/create`, formData).then(response => {
                if (response.data.status == 'success') {
                    get_product_meta();
                    set_modal_show(false);
                    notify(toast,'success',response.data.message);
                    set_add_product_btn_disabled(false);
                }
            })
            .catch(error => {
                set_add_product_btn_disabled(false);
                if (axios.isAxiosError(error) && error.response) {
                    notify(toast,'error',error.response.data.message);
                } else {
                    notify(toast,'error','Server error! Please try again later.');
                }
            });
        }
    }

    // End of product meta

    return (
        <>
           <Helmet>
                <title>Products Meta - Stock Inventody</title>
            </Helmet>
            <Loader allow_access={allow_access}/>
            <ToastContainer />
            <Header inputText={inputText} setinputText={setinputText} searching={searching} set_searching={set_searching} active_bc='product_meta' breadcrumb_product_name={breadcrumb_product_name} breadcrumb_product_meta_name={breadcrumb_product_meta_name}/>

            <Container>
                <div className="category_list_block my-3 py-5">
                    <Row className="justify-content-center">
                        {

                            (<Col className="col-md-10 col d-flex justify-content-between mb-3">
                                <div className="d-flex align-items-center search_bar position-relative">
                                    <Form.Control
                                    type="text"
                                    placeholder="Search"
                                    className=" mr-sm-2 search_field"
                                    ref={inputRef}
                                    onKeyUp={() => {inputChange()}}
                                    disabled={(searching !== undefined && searching == true ) ? true : false}
                                    />
                                    <img
                                    src= {Search}
                                    width="20"
                                    height="20"
                                    className="d-inline-block align-top search_icon"
                                    alt="search icon"
                                    />
                                </div>
                                {
                                    access.includes('AddProductMeta') ?
                                    <Button onClick={() => open_product_modal()} className="primary mt-sm-0 mt-2 d-flex justify-content-around align-items-center add_new_btn ">
                                        <img src= {Addnew} width="15" height="15" className="d-inline-block" alt="add icon" /> ADD NEW
                                    </Button>
                                    : null
                                }

                            </Col>)
                        }
                        <Col xs md="10">
                            <div className="category_list_inner">
                                <Table responsive="sm" size="sm" className={searching == true ? 'catgeory_list_group searching' : 'catgeory_list_group'}>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th style={{textAlign:"left"}}>Item Name</th>
                                            <th style={{textAlign:"left"}}>Item Quantity</th>
                                            {
                                                access.includes("UpdateProductMeta") || access.includes("DeleteProductMeta")
                                                ?
                                                    <th className="option_item">Options</th>
                                                : null
                                            }

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            product_meta !== undefined && product_meta.length > 0
                                            ?
                                            product_meta.map((product,product_key) => {
                                                    return (
                                                        <tr key={product_key}>
                                                            <td>
                                                                <div className="m-auto category_link">

                                                                        <img
                                                                            src={Angleright}
                                                                            width="15"
                                                                            height="15"
                                                                            className="d-inline-block align-top"
                                                                            alt="Arrow Angle right"
                                                                        />
                                                                </div>
                                                            </td>
                                                            <td style={{textAlign:"left",width:"50%"}}>{product.metaKey}</td>
                                                            <td style={{textAlign:"left",width:"30%"}}>{product.metaValue}</td>
                                                            {
                                                                access.includes("UpdateProductMeta") || access.includes("DeleteProductMeta")
                                                                ?
                                                                    (<td className="option_data">
                                                                        <div className="ms-auto category_options">
                                                                            <Dropdown>
                                                                                <Dropdown.Toggle variant="light" id="dropdown-1" className="toggle_dots m-auto">
                                                                                    Actions
                                                                                </Dropdown.Toggle>

                                                                                <Dropdown.Menu>
                                                                                    {
                                                                                        access.includes("UpdateProductMeta") ? (<Dropdown.Item onClick={() => {set_edit_product_meta_key(product.metaKey);set_edit_product_id(product.product_id);set_edit_product_cat_id(product.category_id);edit_product(product.id,product.category_id,product.product_id,product.metaKey,product.metaValue);}}><img src={EditIc} width="15" height="15" className="d-inline-block me-2" alt="Edit Icon"/> Edit</Dropdown.Item>) : null
                                                                                    }
                                                                                    {
                                                                                        access.includes("DeleteProductMeta") ? (<Dropdown.Item onClick={() => {deleteConfirm(product.id,product.category_id,product.product_id);set_delete_product_meta_key(product.metaKey);set_delete_product_id(product.product_id);set_delete_product_cat_id(product.category_id)}}><img src={DeleteDarkIc} width="15" height="15" className="d-inline-block me-2" alt="Delete Icon"/> Delete</Dropdown.Item>) : null
                                                                                    }
                                                                                </Dropdown.Menu>
                                                                            </Dropdown>
                                                                        </div>
                                                                    </td>)
                                                                : null

                                                            }

                                                        </tr>
                                                    )
                                                })
                                            :   (<tr>
                                                    <td colSpan={access.includes("UpdateProductMeta") || access.includes("DeleteProductMeta") ? 4 : 3}>
                                                        <h5 className="m-auto text-center">
                                                            No product Meta found
                                                        </h5>
                                                    </td>
                                                </tr>)
                                        }

                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
            <Modal show={modal_show} onHide={modal_close}>
                <Modal.Header closeButton>
                <Modal.Title>Add Product Meta</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="form_input_block" controlId="formGroupEmail">
                        <Form.Label>Item Name</Form.Label>
                        <Form.Control type="text" ref={add_meta_key_ref} defaultValue={add_meta_key_input} placeholder="Item Name" onKeyUp={() => {set_add_meta_key_error('')}} autoComplete="off"/>
                        {add_meta_key_error != '' ? (<div className="text-danger mt-2 ms-2">{add_meta_key_error}</div>) : null}
                    </Form.Group>
                    <Form.Group className="form_input_block" controlId="formGroupEmail">
                        <Form.Label>Item Quantity</Form.Label>
                        <Form.Control type="text" min="0" ref={add_meta_value_ref} defaultValue={add_meta_value_input} placeholder="Item Quantity" onKeyUp={() => {set_add_meta_value_error('')}} autoComplete="off"/>
                        {add_meta_value_error != '' ? (<div className="text-danger mt-2 ms-2">{add_meta_value_error}</div>) : null}
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={modal_close}>
                    Close
                </Button>
                <Button variant="primary" onClick={() => {add_product_meta()}} disabled={add_product_btn_disabled == true ? true : false}>
                    <img src= {Addnew} width="15" height="15" className="d-inline-block" alt="add icon" /> Add Product Meta
                </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={delete_modal_show} onHide={delete_modal_close}>
                <Modal.Header closeButton>
                <Modal.Title>Delete Product Meta</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h5>Are you sure you want to delete product Meta?</h5>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={delete_modal_close}>
                    Close
                </Button>
                <Button variant="primary" onClick={() => {delete_product_meta()}} disabled={delete_product_btn_disabled == true ? true : false}>
                    <img src={DeleteIc} width="15" height="15" className="d-inline-block" alt="Delete Icon"/>  Delete Product Meta
                </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={edit_modal_show} onHide={edit_modal_close}>
                <Modal.Header closeButton>
                <Modal.Title>Update Product Meta</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="form_input_block" controlId="formGroupEmail">
                        <Form.Label>Item Quantity</Form.Label>
                        <Form.Control type="text" min="0" ref={edit_meta_value_ref} defaultValue={edit_meta_value_input} placeholder="Item Quantity" onKeyUp={() => {set_edit_meta_value_error('')}}  autoComplete="off" />
                        {edit_meta_value_error != '' ? (<div className="text-danger mt-2 ms-2">{edit_meta_value_error}</div>) : null}
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={edit_modal_close}>
                    Close
                </Button>
                <Button variant="primary" onClick={() => {update_product()}} disabled={update_product_btn_disabled == true ? true : false}>
                    <img src={SaveIc} width="15" height="15" className="d-inline-block" alt="Save Icon"/> Update Product Meta
                </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ViewProductMeta;